import request from "@/router/axios";

const baseUrl = "/api/produce/out-in-stock-record/dimension";

export const getConfig = () => {
  return request({
    url: `${baseUrl}/config`,
    method: "get",
  });
};

export const getSummary = (data) => {
  return request({
    url: `${baseUrl}/summary`,
    method: "post",
    data,
  });
};

export const getGroups = (data) => {
  return request({
    url: `${baseUrl}/groups`,
    method: "post",
    data,
  });
};

export const getStages = (data) => {
  return request({
    url: `${baseUrl}/stages`,
    method: "post",
    data,
  });
};

export const getPage = (data) => {
  return request({
    url: `${baseUrl}/page`,
    method: "post",
    data,
  });
};

export const getDetail = (id) => {
  return request({
    url: `${baseUrl}/detail`,
    method: "get",
    params: { id },
  });
};

export const exportExcel = (data) => {
  return request({
    url: "/api/produce/out-in-stock-record/dimensional-transport/export",
    method: "post",
    data,
    responseType: "blob",
  });
};

export const getCustomerOptions = (deptName) => {
  return request({
    url: "/api/produce/blade-dept/select/distinct/select",
    method: "get",
    params: deptName ? { deptName } : {},
  });
};

export const getCargoOptions = (varName) => {
  return request({
    url: "/api/produce/vardict/select/distinct/pycode",
    method: "get",
    params: varName ? { varName } : {},
  });
};
